import { motion } from "framer-motion";
import { MaskLines } from "@/components/Motion";
import { EASE } from "@/lib/api";

export const PageHero = ({ eyebrow, lines, intro, testId }) => (
  <section data-testid={testId} className="mx-auto max-w-[1440px] px-5 md:px-10 pt-36 md:pt-44 pb-14 md:pb-20">
    <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} className="eyebrow mb-6">
      {eyebrow}
    </motion.p>
    <div className="grid md:grid-cols-12 gap-8 items-end">
      <MaskLines onLoad as="h1" lines={lines} className="md:col-span-8 font-display font-light text-6xl sm:text-7xl lg:text-[7.5rem] leading-[0.92] tracking-tight" />
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5, ease: EASE }}
          className="md:col-span-4 text-base md:text-lg text-mocha leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
